import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";

export default function Landing() {
  useEffect(() => {
    document.title =
      "Perficient Building Services — Electrical, Plumbing, Gas, AC & Maintenance";
    const meta = document.querySelector('meta[name="description"]');
    const description =
      "Professional electrical, plumbing, gas, air conditioning and property maintenance services for domestic and commercial customers. Free quotes, fast response.";
    if (meta) meta.setAttribute("content", description);
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}
